export default {
  name: 'Zobrazovaný názov',
  description: 'Popis',
  color: 'Farba',
  unit: 'Jednotka',
  meaning: 'Význam',
  meaningNumber: 'Číslo inštancie významu',
  numberOfSignificantDigits: 'Platné číslice',
  hidden: 'Skryté',
  visible: 'Viditeľné',
  placeholder: {
    meaningId: 'Vybrať význam',
    meaningInstanceNumber: 'Číslo inštancie',
  },
};
